import { StateCreator } from 'zustand';
import { createAppStore } from '@marriott/mi-store-utils';
import { WISHLIST_MODAL_TYPE } from '../utils/constants';
export interface WishlistModalState {
  modalType: WISHLIST_MODAL_TYPE | null;
  wishlistId: string | null;
  setModalType: (type: WISHLIST_MODAL_TYPE | null) => void;
  setWishlistId: (id: string | null) => void;
}

const initialState = {
  modalType: null,
  wishlistId: null,
};

const wishlistModalStore: StateCreator<WishlistModalState> = set => ({
  ...initialState,
  setModalType: type => set(() => ({ modalType: type })),
  setWishlistId: id => set(() => ({ wishlistId: id })),
});

export const useWishlistModalStore = createAppStore(wishlistModalStore, {
  usePersistentStore: false,
});
